import {
  FeedbackError,
  normalizeError
} from "./chunk-RNF7XJWR.js";

// src/axios.ts
import axios from "axios";
var axiosFetcher = async ({ url, method, body, signal }) => {
  let data;
  let status;
  try {
    const response = await axios.request({ url, method, data: body, signal });
    data = response.data;
    status = response.status;
  } catch (error) {
    throw normalizeError(error);
  }
  if (typeof data === "string") {
    if (data.trim() === "") return null;
    throw new FeedbackError({ status, detail: "The feedback service did not answer with JSON." });
  }
  return data != null ? data : null;
};
export {
  axiosFetcher
};
